import React, { useEffect, useState } from 'react'
import Dialog from '../../common/Dialog'
import $t from '../../../i18n'
import { useSelector, useDispatch } from 'react-redux'
import { Button } from 'antd'
import Actions from '../../../actions'
import MaterialInput from '../../common/MaterialInput'
import { getOwnerMember } from 'utils/memberUtils'
import { isEmpty } from 'lodash'
import { useLocation } from 'react-router'
import { ROUTE_STEP } from 'consts/flowConsts'

import './ShareProgressDialog.css'

const getValidationErrors = ({ email }) => {
  const result = {}

  // 11 digits - 10 phone + 1 country code
  const EMAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (!email || !email?.toLowerCase()?.match(EMAIL_REGEX)) {
    result.email = $t('errors.validation.invalidEmail')
  }

  return (!isEmpty(result) && result) || null
}

const ShareProgressDialog = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const [email, setEmail] = useState('')
  const [shouldValidate, setShouldValidate] = useState(false)

  const isShareApplicationDialogVisible = useSelector(
    state => state.app?.isShareApplicationDialogVisible
  )
  const isShareApplicationLoading = useSelector(
    state => state.application?.isShareApplicationLoading
  )
  const members = useSelector(state => state.member.members)
  const ownerMember = getOwnerMember(members)

  const errors = shouldValidate && getValidationErrors({ email })

  useEffect(() => {
    if (ownerMember) {
      setEmail(ownerMember?.email)
    }
  }, [ownerMember])

  const closeDialog = () => {
    dispatch(Actions.createAction(Actions.SHARE_APPLICATION_DIALOG_CLOSED))
  }

  const updateOwnerFields = () => {
    // update email for owner member
    dispatch(
      Actions.createAction(Actions.MEMBER_INFO_CHANGED, {
        key: 'email',
        value: email,
        id: ownerMember?.id
      })
    )
  }

  const onSend = () => {
    if (getValidationErrors({ email })) {
      setShouldValidate(true)
      return
    }
    setShouldValidate(false)
    updateOwnerFields()
    const path = location?.path ? location?.path : location?.pathname

    dispatch(
      Actions.createAction(Actions.SHARE_APPLICATION_REQUESTED, {
        step: ROUTE_STEP[path],
        saveProgressEmailRequested: true,
        skipNavigation: true,
        origin: 'share_application'
      })
    )
  }
  return (
    <Dialog
      title={$t('dialogs.shareApplication.title')}
      isVisible={isShareApplicationDialogVisible}
      footerActions={[]}
      onCancel={closeDialog}
      className='share-progress-dialog'
    >
      <div className='share-progress-dialog-content'>
        <div className='share-progress-subtitle subtitle'>
          {$t('dialogs.shareApplication.description')}
        </div>
        <div className='fields-container'>
          <div className='fields'>
            <MaterialInput
              label={$t('fields.email')}
              value={email}
              errorText={errors?.email}
              onChange={e => setEmail(e?.target?.value)}
            />
          </div>

          <Button
            className='dialog-action'
            type='primary'
            onClick={onSend}
            loading={isShareApplicationLoading}
          >
            {$t('common.continue')}
          </Button>
        </div>
      </div>
    </Dialog>
  )
}

export default ShareProgressDialog
